import { useMutation } from "react-query";
import { updateFileCategory } from "../../../../../actions/Utilities/FileCategory";
import { toast } from "components/toastNotification";
import { IFileCategory } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateFileCategory, fileCategoryReFetching } from "../atoms/atoms";

const useEditFileCategory = () => {
  const setActionEditState = useSetRecoilState(editStateFileCategory);
  const [isReFetching, setIsReFetching] = useRecoilState(
    fileCategoryReFetching
  );
  const { mutate } = useMutation(
    (Data: IFileCategory) => updateFileCategory(Data),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating File Category failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "File Category Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `File Category Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating File Category failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating File Category failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating File Category failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Updating File Category failed", `${res}`, "error");
          }
        }
        // Redirect to View
        setActionEditState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update File Category failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditFileCategory;
